/**
 * Targeted Landing Pages Data & SEO Silos for WrapYourWish
 * Covers High-Value Corporate B2B, Event/Personal Gifting, and Local B2B Hubs.
 */

export const SEO_LANDING_PAGES = {
  'employee-welcome-kits': {
    slug: 'employee-welcome-kits',
    canonicalPath: '/employee-welcome-kits',
    silo: 'corporate',
    title: 'Employee Onboarding Kit Suppliers in India | Custom Welcome Kits | WrapYourWish',
    metaDescription: 'Leading employee onboarding kit suppliers in India. Premium welcome hampers, tech swag, personalized stationery & work anniversary kits with GST billing & PAN India dispatch.',
    keywords: 'employee onboarding kit suppliers India, employee welcome kits, new joiner gift hamper, work anniversary welcome kits, corporate onboarding swag India, custom employee gifts',
    badge: 'Employee Welcome & Retention',
    heroH1: 'Employee Onboarding Kits & Welcome Hampers, Crafted for Impact.',
    heroSubtitle: 'Welcome your new team members with curated joiner kits, branded tech swag, and personalized stationery. Handled end-to-end with PAN-India doorstep delivery.',
    heroImage: 'https://images.unsplash.com/photo-1668127494486-f27a1d2b88f9',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Corporate Gifting', path: '/corporate-gifting' },
      { name: 'Employee Welcome Kits', path: '/employee-welcome-kits' },
    ],
    highlights: [
      { label: 'Low MOQ', value: 'From 25 Kits' },
      { label: 'Rapid Proofing', value: 'Sample in 48h' },
      { label: 'Tax Compliant', value: '100% GST Billing' },
      { label: 'Nationwide Reach', value: 'PAN India Doorstep' },
    ],
    valuePropsTitle: 'Why India’s Top People Teams Trust WrapYourWish',
    valueProps: [
      {
        title: 'Complete Personalization & Logo Branding',
        desc: 'Laser-engraved thermal flasks, embossed vegan leather notebooks, and branded sleeves that showcase your company culture from Day 1.',
        icon: 'Sparkles',
      },
      {
        title: 'Direct-to-Employee Doorstep Logistics',
        desc: 'Whether hiring hybrid teams in Delhi NCR or remote engineers in Bangalore and Pune, we kit, pack, and courier directly to individual homes.',
        icon: 'Truck',
      },
      {
        title: 'Automated Work Anniversary & Milestone Packs',
        desc: 'Schedule recurring shipments for 1-year, 3-year, and 5-year work anniversaries so no employee milestone is ever missed.',
        icon: 'Clock',
      },
      {
        title: 'GST Invoicing & Enterprise Sourcing',
        desc: 'Streamlined vendor onboarding, unified tax invoicing, and credit payment terms for verified enterprise procurement departments.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'kit-apex-exec',
        name: 'The Apex Executive Onboarding Kit',
        price: '₹ 1,899',
        tag: 'Bestseller',
        category: 'Employee Onboarding',
        img: 'https://images.unsplash.com/photo-1608755728617-aefab37d2edd',
        alt: 'Apex Executive employee onboarding kit with custom engraved thermal bottle, diary, and metal pen',
        desc: 'Includes matte black vacuum insulated bottle, hardbound faux leather organizer, metal stylus pen, and branded welcome card in a magnetic box.',
      },
      {
        id: 'kit-tech-starter',
        name: 'The Modern Tech Welcome Box',
        price: '₹ 2,499',
        tag: 'Tech Swag',
        category: 'Employee Onboarding',
        img: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e',
        alt: 'Modern Tech employee welcome box with wireless charger, bluetooth earphones, and custom diary',
        desc: 'Fast wireless charging dock, premium braided charging cable, bluetooth earbuds, and bespoke branded desk organizer.',
      },
      {
        id: 'kit-eco-conscious',
        name: 'Eco-Conscious Green Welcome Hamper',
        price: '₹ 1,499',
        tag: 'Sustainable',
        category: 'Employee Onboarding',
        img: 'https://images.unsplash.com/photo-1606498679463-30a0eb8824e1',
        alt: 'Eco-friendly sustainable employee welcome hamper with bamboo bottle, seed diary, and jute tote',
        desc: 'Handcrafted bamboo tumbler, plantable seed paper diary, seed pencils, organic brass bookmark, and a reusable canvas tote bag.',
      },
      {
        id: 'kit-anniversary-cheer',
        name: 'Milestone Work Anniversary Hamper',
        price: '₹ 2,899',
        tag: 'Milestone',
        category: 'Work Anniversaries',
        img: 'https://images.unsplash.com/photo-1694481901573-a970f982ac5e',
        alt: 'Milestone work anniversary corporate gift hamper with gourmet treats, trophy memento, and personalized desk speaker',
        desc: 'Curated premium dry fruit jar, brass desk memento with laser tenure engraving, bluetooth speaker, and personalized leadership letter.',
      },
    ],
    faqs: [
      {
        q: 'What is the minimum order quantity (MOQ) for custom employee welcome kits?',
        a: 'For custom-branded employee welcome kits with company logos, our standard MOQ starts at just 25 kits. We also offer batch warehousing where you order in bulk to lock in volume discounts, and we dispatch individually as new joiners sign up.',
      },
      {
        q: 'Can we receive a physical sample kit before placing our bulk order?',
        a: 'Yes, absolutely! We dispatch custom-branded or curated prototype sample kits within 48 hours to your office so your HR and leadership team can inspect the materials, printing quality, and packaging finish firsthand.',
      },
      {
        q: 'How long does production and PAN-India delivery take?',
        a: 'Standard production for custom-branded welcome kits takes 5 to 7 business days following artwork sign-off. We partner with Tier-1 express air and surface couriers to ensure pan-India delivery across all major metro and tier-2 pincodes.',
      },
      {
        q: 'Can you deliver directly to remote employees’ home addresses?',
        a: 'Yes. We offer turnkey address collection portals and individual doorstep fulfillment with real-time tracking IDs shared directly with your HR operations team.',
      },
      {
        q: 'Do you provide full GST billing for corporate tax credit?',
        a: 'Yes. Every order is billed with formal GST invoices specifying HSN codes, allowing corporate clients to easily claim input tax credit (ITC).',
      },
    ],
  },

  'client-gifting': {
    slug: 'client-gifting',
    canonicalPath: '/client-gifting',
    silo: 'corporate',
    title: 'Bulk Client Gift Hampers | Corporate Client Gifts India | WrapYourWish',
    metaDescription: 'Curate premium bulk client gift hampers that strengthen partnerships and close deals. Luxury curations, custom branding, GST compliance & seamless PAN India shipping.',
    keywords: 'bulk client gift hampers, corporate client gifts, deal closing gifts, client appreciation hampers India, executive corporate gifts, luxury client gift baskets',
    badge: 'B2B Client Relationship Gifting',
    heroH1: 'Elevate Partnerships with Premium Bulk Client Gift Hampers.',
    heroSubtitle: 'Turn business meetings and milestones into enduring client loyalty. Custom gourmet curations, executive accessories, and bespoke luxury packaging tailored for high-stakes partnerships.',
    heroImage: 'https://images.pexels.com/photos/14755150/pexels-photo-14755150.jpeg',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Corporate Gifting', path: '/corporate-gifting' },
      { name: 'Client Gifting', path: '/client-gifting' },
    ],
    highlights: [
      { label: 'Curated Tiering', value: 'INR 999 to 15k+' },
      { label: 'Branding', value: 'Embossing & Wax Seal' },
      { label: 'Fulfillment', value: 'Direct Desk Delivery' },
      { label: 'Verification', value: 'Pre-Shipment QA' },
    ],
    valuePropsTitle: 'Client Hampers That Create Meaningful Brand Recall',
    valueProps: [
      {
        title: 'Executive Gourmet & Artisanal Curations',
        desc: 'Gourmet California almonds, Kashmiri walnuts, imported dark single-origin chocolates, and artisanal organic honey paired with luxury tableware.',
        icon: 'Sparkles',
      },
      {
        title: 'Subtle, Sophisticated Co-Branding',
        desc: 'Understated elegance with tone-on-tone foil stamping, custom silk ribbons, personalized greeting cards, and wax seal closures.',
        icon: 'Package',
      },
      {
        title: 'Deal-Closing & Retainer Renewal Kits',
        desc: 'Specialized gift sets crafted to celebrate contract signings, quarterly business reviews (QBRs), and annual retainer renewals.',
        icon: 'Clock',
      },
      {
        title: 'Dedicated Account Manager',
        desc: 'A single point of contact who manages catalogue curation, mockups, address verification, and delivery escalation management.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'client-royale-gourmet',
        name: 'The Royale Gourmet Client Trunk',
        price: '₹ 3,499',
        tag: 'Executive',
        category: 'Client Gifting',
        img: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48',
        alt: 'Royale Gourmet luxury client gift trunk with dry fruits, artisanal tea, and premium brass accessories',
        desc: 'Leatherette treasure trunk with brass latches, jumbo roasted pistachios, Mamra almonds, single-estate Darjeeling tea, and brass tea strainer.',
      },
      {
        id: 'client-connoisseur-set',
        name: 'The Connoisseur Coffee & Desk Hamper',
        price: '₹ 2,999',
        tag: 'Bestseller',
        category: 'Client Gifting',
        img: 'https://images.unsplash.com/photo-1512909006721-3d6018887383',
        alt: 'Connoisseur client gift box with French press coffee maker, gourmet beans, and ceramic mugs',
        desc: 'Stainless steel French press, artisanal Arabica ground coffee, dual ceramic stoneware mugs, and biscotti jar in a rigid pine wood crate.',
      },
      {
        id: 'client-deal-closer',
        name: 'The Signature Deal Closer Hamper',
        price: '₹ 4,999',
        tag: 'VIP Edition',
        category: 'Client Gifting',
        img: 'https://images.unsplash.com/photo-1513201099705-a9746e1e201f',
        alt: 'Signature deal closer luxury hamper with pen, customized leather folio, and luxury confectioneries',
        desc: 'Cross rollerball pen, genuine leather document folio, luxury dry fruit selection, and personalized congratulatory leadership note.',
      },
      {
        id: 'client-wellness-bliss',
        name: 'The Executive Wellness Retreat Box',
        price: '₹ 2,199',
        tag: 'Wellness',
        category: 'Client Gifting',
        img: 'https://images.unsplash.com/photo-1606498679463-30a0eb8824e1',
        alt: 'Executive wellness client gift box with aromatherapy diffuser, scented soy candle, and herbal tea',
        desc: 'Ceramic ultrasonic aroma diffuser, essential oils blend, hand-poured soy candle, and organic immunity tea blend.',
      },
    ],
    faqs: [
      {
        q: 'What makes your client gift hampers different from retail gift baskets?',
        a: 'Our client hampers are strictly B2B-grade: premium rigid boxes, bespoke co-branding, strict quality inspection of gourmet products with long shelf-life, and customized stationery that ensures your brand commands respect.',
      },
      {
        q: 'Can we send gifts to multiple client office addresses across different cities?',
        a: 'Yes. You simply provide us with your client recipient spreadsheet, and our dispatch team verifies deliverability, coordinates with building receptions, and delivers PAN India with live courier tracking.',
      },
      {
        q: 'What is the lead time for customized client hampers?',
        a: 'Most client hamper orders are ready for dispatch within 4 to 6 business days. Express turnaround (48-72 hours) is available for urgent deal-closing or event emergencies.',
      },
      {
        q: 'Can we include our company CEO / Founder note in each box?',
        a: 'Yes! We design and print customized high-gsm metallic or textured greeting cards with your exact brand typography and personalized leadership messages.',
      },
    ],
  },

  'festive-hampers': {
    slug: 'festive-hampers',
    canonicalPath: '/festive-hampers',
    silo: 'corporate',
    title: 'Corporate Diwali Gifts for Employees & Clients | Festive Hampers | WrapYourWish',
    metaDescription: 'Order corporate Diwali gifts for employees and clients. Luxury dry fruit boxes, artisanal diyas, sweets & curated hampers with custom branding & GST billing.',
    keywords: 'corporate Diwali gifts for employees, corporate Diwali gifts, festive hampers corporate, Diwali gift hampers bulk, corporate New Year gifts India, festive gift boxes',
    badge: 'Festive Season 2026',
    heroH1: 'Corporate Diwali Gifts & Festive Hampers, Curated with Splendor.',
    heroSubtitle: 'Celebrate the triumph of light, gratitude, and teamwork. Premium Diwali dry fruit boxes, artisanal brass diyas, and gourmet festive hampers with custom corporate branding.',
    heroImage: 'https://images.unsplash.com/photo-1625552186152-668cd2f0b707',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Corporate Gifting', path: '/corporate-gifting' },
      { name: 'Festive Hampers', path: '/festive-hampers' },
    ],
    highlights: [
      { label: 'Diwali Bookings', value: 'Open Now' },
      { label: 'Bulk Savings', value: 'Up to 22% Off' },
      { label: 'Gourmet Treats', value: '100% Certified' },
      { label: 'Express NCR Dispatch', value: 'Local Corridor' },
    ],
    valuePropsTitle: 'Stress-Free Festive Corporate Gifting at Scale',
    valueProps: [
      {
        title: 'Pristine Dry Fruits & Sweets',
        desc: 'Finest handpicked jumbo cashews, California almonds, Afghan raisins, and vacuum-sealed authentic Indian gourmet sweets.',
        icon: 'Sparkles',
      },
      {
        title: 'Artisan Brassware & Sustainable Diyas',
        desc: 'Handcrafted bell metal and brass diyas, organic fragrant wax candles, and artisanal torans crafted by traditional Indian artisans.',
        icon: 'Package',
      },
      {
        title: 'Guaranteed Pre-Diwali Delivery',
        desc: 'We bypass peak festive courier traffic through dedicated regional distribution hubs, ensuring gifts reach employees 10-15 days before Diwali.',
        icon: 'Clock',
      },
      {
        title: 'Full GST Credit & Corporate Pricing',
        desc: 'Competitive tier-based bulk pricing starting from ₹ 799 to luxury ₹ 10,000+ hampers with transparent tax invoicing.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'diwali-shubh-utsav',
        name: 'The Shubh Utsav Royal Diwali Box',
        price: '₹ 1,899',
        tag: 'Bestseller',
        category: 'Festive Hampers',
        img: 'https://images.unsplash.com/photo-1625552186152-668cd2f0b707',
        alt: 'Shubh Utsav corporate Diwali gift box with dry fruits, brass diya, and scented candle',
        desc: 'Traditional gold-foiled rigid gift box, premium roasted cashews, California almonds, hand-carved brass diya pair, and organic saffron tea.',
      },
      {
        id: 'diwali-kesar-delight',
        name: 'The Kesar & Mewa Luxury Platter',
        price: '₹ 2,499',
        tag: 'Festive Gourmet',
        category: 'Festive Hampers',
        img: 'https://images.unsplash.com/photo-1596547609652-9cf5d8d76921',
        alt: 'Kesar and Mewa luxury dry fruit platter corporate gift box with wooden partition',
        desc: 'Laser-etched wooden hamper box with 4 compartments filled with Mamra almonds, w320 cashews, Medjool dates, and premium pistachios.',
      },
      {
        id: 'diwali-brass-heritage',
        name: 'Artisanal Brass Heritage Festive Hamper',
        price: '₹ 3,299',
        tag: 'Artisan Crafted',
        category: 'Festive Hampers',
        img: 'https://images.unsplash.com/photo-1513519245088-0e12902e5a38',
        alt: 'Artisanal brass heritage festive gift hamper with brass urli, potpourri, and incense cones',
        desc: 'Hand-hammered brass urli, floating aromatic candles, organic sandalwood incense cones, and silver-plated sweet jar.',
      },
      {
        id: 'diwali-corporate-elite',
        name: 'The Executive Festive Celebration Hamper',
        price: '₹ 1,299',
        tag: 'Budget Favorite',
        category: 'Festive Hampers',
        img: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6',
        alt: 'Executive festive celebration hamper for employees with dry fruits, chocolates, and festive card',
        desc: 'Festive slipcase box with company logo, salted roasted almonds, artisanal chocolate bars, terracotta diyas, and personalized greeting card.',
      },
    ],
    faqs: [
      {
        q: 'When should we book our corporate Diwali gifts to avoid peak shipping delays?',
        a: 'We strongly recommend confirming orders 3 to 4 weeks prior to Diwali. Early bookings guarantee stock availability of premium dry fruits and lock in express delivery slots before courier networks become congested.',
      },
      {
        q: 'What is the minimum order quantity for corporate Diwali hampers?',
        a: 'Our corporate Diwali hampers have an MOQ of 25 units for customized branding. For unbranded or ready-to-ship curations, lower quantities can also be accommodated.',
      },
      {
        q: 'Can we customize the contents of the Diwali gift box to match our budget?',
        a: 'Yes! We customize hampers to any budget between ₹ 600 and ₹ 15,000+ per unit, substituting dry fruits, gadgets, sweets, and lifestyle items according to your preference.',
      },
      {
        q: 'Do you deliver Diwali gifts across multiple branches and employee homes in India?',
        a: 'Yes, we manage centralized multi-office dispatches as well as individual employee doorstep shipping across 28,000+ Indian pincodes.',
      },
    ],
  },

  'wedding-return-gifts': {
    slug: 'wedding-return-gifts',
    canonicalPath: '/wedding-return-gifts',
    silo: 'personal',
    title: 'Wedding Return Gifts Luxury Bulk | Curated Favors & Hampers | WrapYourWish',
    metaDescription: 'Shop luxury bulk wedding return gifts in India. Elegant dry fruit boxes, brassware, artisanal fragrances & personalized favor hampers for your guests.',
    keywords: 'wedding return gifts luxury bulk, wedding return gifts India, wedding favor hampers luxury, personalized wedding favors bulk, luxury wedding return gifts',
    badge: 'Luxury Event Favors',
    heroH1: 'Luxury Wedding Return Gifts & Curated Favors in Bulk.',
    heroSubtitle: 'Express heartfelt gratitude to your wedding guests with handcrafted brassware, artisanal fragrances, gourmet treats, and personalized keepsake packaging.',
    heroImage: 'https://images.unsplash.com/photo-1592903297149-37fb25202dfa',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Personalised Gifting', path: '/personalised-gifting' },
      { name: 'Wedding Return Gifts', path: '/wedding-return-gifts' },
    ],
    highlights: [
      { label: 'Bulk Orders', value: 'From 50 to 2000+' },
      { label: 'Custom Monogram', value: 'Couple Initials' },
      { label: 'Artisan Made', value: 'Pure Brass & Velvet' },
      { label: 'Doorstep Delivery', value: 'Direct to Venue' },
    ],
    valuePropsTitle: 'Wedding Favors That Leave an Everlasting Impression',
    valueProps: [
      {
        title: 'Bespoke Monogramming & Custom Calligraphy',
        desc: 'Gold foil couple insignias, personalized thank you scrolls, and customized wax seals in your wedding color theme.',
        icon: 'Sparkles',
      },
      {
        title: 'Heirloom Brassware & Cultural Keepsakes',
        desc: 'Engraved brass urlis, silver-finished bowls, handcrafted meenakari work, and traditional stone crafts that guests treasure forever.',
        icon: 'Package',
      },
      {
        title: 'Direct-to-Venue Logistics Coordination',
        desc: 'Carefully packaged in heavy-duty transit crates and delivered directly to your wedding hotel or banquet venue across Delhi NCR, Udaipur, Jaipur, or Goa.',
        icon: 'Truck',
      },
      {
        title: 'Tasting & Material Samples',
        desc: 'Inspect finished favor prototypes, dry fruit quality, and packaging textures before finalizing your wedding order.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'wedding-shahi-box',
        name: 'The Shahi Heritage Velvet Box',
        price: '₹ 1,799',
        tag: 'Bestseller',
        category: 'Wedding Return Gifts',
        img: 'https://images.unsplash.com/photo-1592903297149-37fb25202dfa',
        alt: 'Shahi Heritage velvet wedding return gift box with dry fruits and brass candle',
        desc: 'Hand-upholstered royal emerald velvet box with custom monogrammed brass crest, jumbo pistachios, and roasted cashews.',
      },
      {
        id: 'wedding-brass-meenakari',
        name: 'Royal Meenakari Bowl Set in Brocade Casket',
        price: '₹ 1,499',
        tag: 'Traditional',
        category: 'Wedding Return Gifts',
        img: 'https://images.unsplash.com/photo-1513519245088-0e12902e5a38',
        alt: 'Royal Meenakari bowl set wedding return gift in brocade casket box',
        desc: 'Pair of brass meenakari artisan bowls with spoons, presented in an embroidered Banarasi silk storage casket.',
      },
      {
        id: 'wedding-fragrance-botanicals',
        name: 'The Oud & Botanical Fragrance Trunk',
        price: '₹ 2,299',
        tag: 'Luxury Modern',
        category: 'Wedding Return Gifts',
        img: 'https://images.pexels.com/photos/14755150/pexels-photo-14755150.jpeg',
        alt: 'Oud and botanical fragrance wedding gift favor trunk with diffuser and candle',
        desc: 'Reed room diffuser with natural essential oils, soy wax candle in hammered brass cup, and artisan bath truffles.',
      },
      {
        id: 'wedding-gourmet-mithai',
        name: 'Artisan Fusion Mithai & Nut Box',
        price: '₹ 1,299',
        tag: 'Gourmet',
        category: 'Wedding Return Gifts',
        img: 'https://images.unsplash.com/photo-1596547609652-9cf5d8d76921',
        alt: 'Artisan fusion mithai and dry fruit wedding return gift box with customized sleeve',
        desc: 'Gold embossed trunk filled with saffron almond sweets, salted pecans, and personalized couple thank you note.',
      },
    ],
    faqs: [
      {
        q: 'What is the ideal timeline to order bulk wedding return gifts?',
        a: 'We suggest placing your order 3 to 6 weeks before wedding festivities begin. This allows ample time for custom box manufacturing, monogram proofing, and safe venue delivery.',
      },
      {
        q: 'Can we customize the color palette of boxes to match our wedding theme?',
        a: 'Yes! We customize velvet, raw silk, and rigid paper boxes to match your exact wedding palette (ivory, blush, sage, regal navy, emerald, or crimson).',
      },
      {
        q: 'Can you deliver return gifts directly to a destination wedding resort?',
        a: 'Yes. We regularly ship bulk crates directly to destination wedding resorts across Rajasthan (Jaipur, Udaipur), Goa, Kerala, and across India.',
      },
      {
        q: 'What is the minimum quantity for custom wedding favors?',
        a: 'Custom monogrammed wedding return gifts typically start at 50 units. We seamlessly fulfill orders running into thousands of units for large wedding celebrations.',
      },
    ],
  },

  'occasion-gifting': {
    slug: 'occasion-gifting',
    canonicalPath: '/occasion-gifting',
    silo: 'personal',
    title: 'Personalized Baby Shower Hampers & Milestone Gifts | WrapYourWish',
    metaDescription: 'Discover curated anniversary gift baskets, personalized baby shower hampers & milestone gift boxes. Crafted with love, customized with names & delivered across India.',
    keywords: 'personalized baby shower hampers, curated anniversary gift baskets, milestone gifting, baby welcome hampers, curated personal gift baskets India',
    badge: 'Milestones & Celebrations',
    heroH1: 'Personalized Hampers for Life’s Most Cherished Moments.',
    heroSubtitle: 'Celebrate baby showers, milestone anniversaries, and personal achievements with bespoke gift baskets assembled with tenderness and attention to every detail.',
    heroImage: 'https://images.unsplash.com/photo-1513201099705-a9746e1e201f',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Personalised Gifting', path: '/personalised-gifting' },
      { name: 'Occasion Gifting', path: '/occasion-gifting' },
    ],
    highlights: [
      { label: 'Custom Names', value: 'Laser Engraved' },
      { label: 'Theme Styling', value: 'Pastel Curations' },
      { label: 'Safe Sourcing', value: 'Organic Certified' },
      { label: 'Express Gifting', value: 'Pan India Dispatch' },
    ],
    valuePropsTitle: 'Thoughtful Curations for Every Family Milestone',
    valueProps: [
      {
        title: 'Baby Shower & New Mother Wellness',
        desc: 'Organic cotton swaddles, wooden keepsake rattles, lactation herbal teas, and pampering skincare for new mothers.',
        icon: 'Sparkles',
      },
      {
        title: 'Curated Milestone Anniversary Baskets',
        desc: 'Monogrammed wine flutes, luxury scented soy candles, gourmet treats, and keepsake memory photobooks for couples.',
        icon: 'Package',
      },
      {
        title: 'Artisan Packaging & Custom Keepsake Boxes',
        desc: 'Pastel keepsake suitcases, wicker picnic baskets, and reusable wooden chests with hand-tied satin ribbons.',
        icon: 'Truck',
      },
      {
        title: 'Personalized Greeting Calligraphy',
        desc: 'Every gift includes hand-scripted greeting cards capturing your deepest emotions with warmth and grace.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'occ-baby-bundle',
        name: 'The Little Miracle Baby Welcome Hamper',
        price: '₹ 2,499',
        tag: 'Newborn Favorite',
        category: 'Baby Shower',
        img: 'https://images.unsplash.com/photo-1513201099705-a9746e1e201f',
        alt: 'Little miracle baby welcome hamper in pastel storage basket with baby essentials',
        desc: 'Organic bamboo swaddle, handcrafted wooden milestone discs, non-toxic baby bath wash, and keepsake nursery rattle.',
      },
      {
        id: 'occ-anniv-toast',
        name: 'The Golden Milestone Anniversary Basket',
        price: '₹ 3,499',
        tag: 'Anniversary',
        category: 'Anniversary',
        img: 'https://images.unsplash.com/photo-1606498679463-30a0eb8824e1',
        alt: 'Golden milestone anniversary curated gift basket with custom flutes and luxury gourmet treats',
        desc: 'Personalized couple flutes with anniversary date engraving, gourmet chocolate pralines, organic honey, and aromatic diffusers.',
      },
      {
        id: 'occ-mom-glow',
        name: 'The New Mom Pamper & Rest Hamper',
        price: '₹ 2,199',
        tag: 'Motherhood',
        category: 'Baby Shower',
        img: 'https://images.pexels.com/photos/32188338/pexels-photo-32188338.jpeg',
        alt: 'New mom pamper and relaxation hamper with botanical body oil and herbal tea',
        desc: 'Botanical rose body oil, lavender bath salts, organic nursing tea blend, and satin eye mask in a keepsake trunk.',
      },
      {
        id: 'occ-housewarming-bliss',
        name: 'New Beginnings Housewarming Crate',
        price: '₹ 2,899',
        tag: 'Housewarming',
        category: 'Housewarming',
        img: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8',
        alt: 'New beginnings housewarming gift crate with brass planters, artisan coffee, and gourmet snacks',
        desc: 'Brass indoor planter, hand-poured ceramic candle, artisanal coffee jar, and brass key hook organizer.',
      },
    ],
    faqs: [
      {
        q: 'Can we personalize items with the baby’s or couple’s name?',
        a: 'Yes, we offer laser engraving and custom embroidery to print baby names, birth dates, or couple monograms onto blankets, wooden toys, boxes, and glassware.',
      },
      {
        q: 'Are the baby hamper products certified baby-safe and non-toxic?',
        a: 'Absolutely. All baby-care elements are made with 100% organic cotton, chemical-free natural dyes, and splinter-free beechwood.',
      },
      {
        q: 'Can I order a single personalized hamper or are these only in bulk?',
        a: 'For personal celebrations like baby showers and anniversaries, you can order individual curations as well as bulk party favors.',
      },
      {
        q: 'How quickly can an anniversary or baby shower hamper be delivered?',
        a: 'Ready-to-ship personal hampers dispatch within 24 hours. Custom engraved curations dispatch in 2 to 3 days with express air delivery across India.',
      },
    ],
  },

  'corporate-gifting-delhi-ncr': {
    slug: 'corporate-gifting-delhi-ncr',
    canonicalPath: '/corporate-gifting-delhi-ncr',
    silo: 'local',
    title: 'Corporate Gifting Companies in Delhi NCR | Noida, Gurgaon, Ghaziabad | WrapYourWish',
    metaDescription: 'Premier corporate gifting company in Delhi NCR. Custom employee welcome kits, client hampers & festive gifts with studio in Ghaziabad, same-day samples & fast local dispatch.',
    keywords: 'corporate gifting companies in Delhi NCR, corporate gifting Noida, corporate gifts Ghaziabad, corporate gifts Delhi, corporate gift suppliers Delhi NCR, corporate welcome kits Delhi',
    badge: 'Local Studio & Fulfillment Hub',
    heroH1: 'Delhi NCR’s Leading Corporate Gifting Studio & Supplier.',
    heroSubtitle: 'Based in Rajendra Nagar Industrial Area, Ghaziabad, we cater to tech hubs, manufacturing leaders, and MNCs across Delhi, Noida, Gurgaon, and Faridabad with fast sample prototyping and reliable local fulfillment.',
    heroImage: 'https://images.unsplash.com/photo-1668127494486-f27a1d2b88f9',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Corporate Gifting', path: '/corporate-gifting' },
      { name: 'Delhi NCR Corporate Gifting', path: '/corporate-gifting-delhi-ncr' },
    ],
    highlights: [
      { label: 'Local Studio', value: 'Ghaziabad, UP' },
      { label: 'NCR Prototype', value: 'Sample in 24-48h' },
      { label: 'Fleet Delivery', value: 'Doorstep NCR Dispatches' },
      { label: 'Enterprise Ready', value: '100% GST Invoicing' },
    ],
    valuePropsTitle: 'The Delhi NCR Advantage with WrapYourWish',
    valueProps: [
      {
        title: 'Local Production & Rapid Sampling in NCR',
        desc: 'Our studio in Rajendra Nagar Industrial Area, Ghaziabad allows Delhi NCR clients to inspect materials in-person or receive physical samples within 24 hours.',
        icon: 'Sparkles',
      },
      {
        title: 'Dedicated Local Delivery Corridors',
        desc: 'Avoid 3rd-party logistics gridlock during festive rush hours with our dedicated NCR fulfillment vehicles servicing Noida Sector 62/132, Okhla, CP, and Gurgaon.',
        icon: 'Truck',
      },
      {
        title: 'Emergency Orders & Fast Turnaround',
        desc: 'Got an urgent town hall or conference in Delhi NCR? We assemble, brand, and deliver emergency batches in as little as 48 to 72 hours.',
        icon: 'Clock',
      },
      {
        title: 'Local Client Base Across Major Business Parks',
        desc: 'Trusted by leading enterprises, hospitals, and CA firms across World Trade Tower, DLF Cyber City, Unitech Infospace, and Advant Navis.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'ncr-welcome-pack',
        name: 'The NCR Enterprise Onboarding Box',
        price: '₹ 1,799',
        tag: 'Delhi NCR Favorite',
        category: 'Employee Onboarding',
        img: 'https://images.unsplash.com/photo-1608755728617-aefab37d2edd',
        alt: 'Enterprise employee onboarding kit for Delhi NCR companies with water bottle and notebook',
        desc: 'Insulated stainless bottle with company engraving, matte hardbound notebook, metal pen, and tech cable in a rigid box.',
      },
      {
        id: 'ncr-client-luxury',
        name: 'The Lutyens Executive Client Hamper',
        price: '₹ 3,499',
        tag: 'Executive',
        category: 'Client Gifting',
        img: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48',
        alt: 'Lutyens executive corporate client gift hamper with gourmet dry fruits and brass accessory',
        desc: 'Handmade leatherette trunk with w320 cashews, roasted pistachios, Kashmiri saffron, and handcrafted brass coaster set.',
      },
      {
        id: 'ncr-eco-green',
        name: 'The Sustainable Capital Green Box',
        price: '₹ 1,399',
        tag: 'Eco Friendly',
        category: 'Sustainable Gifts',
        img: 'https://images.unsplash.com/photo-1606498679463-30a0eb8824e1',
        alt: 'Sustainable capital eco friendly corporate gift hamper with bamboo flask and plantable stationery',
        desc: 'Bamboo travel mug, plantable stationery kit, jute laptop pouch, and ceramic desk succulent planter.',
      },
      {
        id: 'ncr-festive-royal',
        name: 'The Delhi Durbar Festive Hamper',
        price: '₹ 2,199',
        tag: 'Festive Bestseller',
        category: 'Festive Hampers',
        img: 'https://images.unsplash.com/photo-1625552186152-668cd2f0b707',
        alt: 'Delhi Durbar corporate festive hamper with brass diya and gourmet dry fruits',
        desc: 'Traditional gold foil box with brass bell diya, California almonds, Afghan raisins, and organic scented candles.',
      },
    ],
    faqs: [
      {
        q: 'Where is WrapYourWish located in Delhi NCR?',
        a: 'Our central gifting studio and fulfillment warehouse is located at Rajendra Nagar Industrial Area, Ghaziabad, Uttar Pradesh (Pin 201005). We regularly host client procurement heads for material reviews.',
      },
      {
        q: 'How fast can you deliver samples to our office in Delhi, Noida, or Gurgaon?',
        a: 'Because our central operations are based in NCR, prototype and sample kits can be dispatched and delivered directly to your office within 24 to 48 hours.',
      },
      {
        q: 'Do you offer same-day or dedicated fleet delivery in Delhi NCR for bulk orders?',
        a: 'Yes. During peak festive periods like Diwali or major corporate events, we deploy dedicated fleet vehicles directly to your corporate headquarters in Delhi, Noida, or Gurgaon.',
      },
      {
        q: 'Can we visit your studio to inspect gifts in person?',
        a: 'Yes, corporate HR and procurement teams are welcome to visit our Ghaziabad studio. Please call or WhatsApp us at +91 88605 53236 to schedule an appointment with a corporate gifting stylist.',
      },
    ],
  },

  'corporate-gifting-gurgaon': {
    slug: 'corporate-gifting-gurgaon',
    canonicalPath: '/corporate-gifting-gurgaon',
    silo: 'local',
    title: 'Corporate Gifting Companies in Gurgaon | Cyber City Tech Swag & Hampers | WrapYourWish',
    metaDescription: 'Trusted corporate gifting partner for Gurgaon enterprise and tech firms. Cyber City employee welcome kits, executive hampers, custom branding & doorstep delivery.',
    keywords: 'corporate gifting companies in Gurgaon, corporate gifts Cyber City Gurgaon, employee onboarding kits Gurgaon, corporate gift hampers Gurugram, corporate gift suppliers Gurgaon',
    badge: 'Gurgaon Tech & Corporate Hub',
    heroH1: 'Corporate Gifting & Welcome Kits for Gurgaon’s Tech & MNC Giants.',
    heroSubtitle: 'From DLF Cyber City to Golf Course Extension Road, we power high-growth startups, consulting firms, and Fortune 500 teams with modern employee swag, tech kits, and executive client hampers.',
    heroImage: 'https://images.unsplash.com/photo-1608755728617-aefab37d2edd',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Corporate Gifting', path: '/corporate-gifting' },
      { name: 'Corporate Gifting Gurgaon', path: '/corporate-gifting-gurgaon' },
    ],
    highlights: [
      { label: 'Gurgaon Dispatches', value: 'Direct Desk Delivery' },
      { label: 'Tech & Lifestyle', value: '4,000+ Products' },
      { label: 'Branding', value: 'Full Co-Branding' },
      { label: 'Invoicing', value: 'Haryana / UP GST Ready' },
    ],
    valuePropsTitle: 'Built for the Speed and Quality Gurgaon Demands',
    valueProps: [
      {
        title: 'Modern Tech Swag & Premium Electronics',
        desc: 'Brand partners like Boat, Noise, Portronics, JBL, and Philips to equip your software engineers and product teams with premium gadgets.',
        icon: 'Sparkles',
      },
      {
        title: 'Cyber City & Golf Course Road Logistics',
        desc: 'Direct building-level delivery coordination with facility managers at DLF CyberHub, Horizon Center, Candor TechSpace, and Udyog Vihar.',
        icon: 'Truck',
      },
      {
        title: 'Automated Joiner Kits for Fast-Hiring Startups',
        desc: 'Store your custom-branded welcome swag in our facility and trigger automated dispatches as new hires join your Gurgaon offices.',
        icon: 'Clock',
      },
      {
        title: 'Compliant Vendor Onboarding',
        desc: 'Complete compliance documentation, NDA coverage, and GST billing for seamless integration into enterprise ERP procurement systems.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'ggn-cyber-kit',
        name: 'The CyberHub Tech Pioneer Kit',
        price: '₹ 2,499',
        tag: 'Tech Favorite',
        category: 'Employee Onboarding',
        img: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e',
        alt: 'CyberHub tech pioneer employee welcome kit for Gurgaon tech companies with earbuds and gadget bag',
        desc: 'Bluetooth active wireless earbuds, multiport fast charging hub, anti-spill suction mug, and vegan leather tech folio.',
      },
      {
        id: 'ggn-exec-boardroom',
        name: 'The Horizon Boardroom Client Hamper',
        price: '₹ 3,999',
        tag: 'Executive',
        category: 'Client Gifting',
        img: 'https://images.unsplash.com/photo-1512909006721-3d6018887383',
        alt: 'Horizon boardroom luxury client gift hamper for Gurgaon consulting and financial firms',
        desc: 'Sleek matte gift trunk with Cross ballpoint pen, premium Mamra almonds, Italian roast coffee, and personalized letterhead.',
      },
      {
        id: 'ggn-sustainable-desk',
        name: 'The Green Millennial Desk Essentials',
        price: '₹ 1,599',
        tag: 'Sustainable',
        category: 'Sustainable Gifts',
        img: 'https://images.unsplash.com/photo-1606498679463-30a0eb8824e1',
        alt: 'Green millennial desk essentials eco friendly welcome kit with cork planner and bamboo bottle',
        desc: 'Cork cover daily journal, bamboo thermal bottle, seed pens, and an organic desk succulent plant.',
      },
      {
        id: 'ggn-anniv-spotlight',
        name: 'Gurgaon Tenure & Excellence Award Box',
        price: '₹ 2,799',
        tag: 'Recognition',
        category: 'Rewards & Recognition',
        img: 'https://images.unsplash.com/photo-1694481901573-a970f982ac5e',
        alt: 'Gurgaon tenure and excellence award corporate gift box with acrylic trophy and bluetooth speaker',
        desc: 'Engraved tenure crystal desk memento, premium audio speaker, artisanal gourmet nuts, and personalized congratulatory card.',
      },
    ],
    faqs: [
      {
        q: 'Do you deliver directly to commercial tech parks in Gurgaon?',
        a: 'Yes, our delivery network routinely services Cyber City, Horizon Center, Golf Course Road, Candor TechSpace, Udyog Vihar, and Sohna Road.',
      },
      {
        q: 'Can Gurgaon companies get physical product samples before approving a purchase order?',
        a: 'Yes. We courier custom-branded or curated prototype kits straight to your Gurgaon office within 24 to 48 hours for HR and leadership review.',
      },
      {
        q: 'Can you handle individual dispatches to Gurgaon-based remote employees?',
        a: 'Yes. We deliver directly to apartments, condominiums, and residences across DLF Phases 1-5, Golf Course Road, and New Gurgaon.',
      },
      {
        q: 'Can we co-brand branded electronics like JBL, Boat, or Portronics?',
        a: 'Yes! As official corporate gifting partners with top tech brands, we offer legitimate OEM-authorized screen printing and laser etching on branded electronics.',
      },
    ],
  },

  'corporate-gifts-bangalore': {
    slug: 'corporate-gifts-bangalore',
    canonicalPath: '/corporate-gifts-bangalore',
    silo: 'local',
    title: 'Corporate Gifts Bangalore | Employee Swag & Onboarding Kits | WrapYourWish',
    metaDescription: 'High-impact corporate gifts in Bangalore. Modern onboarding kits, startup swag, client hampers & festive gifts for Whitefield, Koramangala & Electronic City.',
    keywords: 'corporate gifts Bangalore, employee welcome kits Bangalore, corporate gifting companies Bangalore, startup swag kits Bangalore, corporate gift hampers Bangalore',
    badge: 'Silicon Valley of India',
    heroH1: 'Smart Corporate Gifting & Welcome Kits for Bangalore’s Tech Campuses.',
    heroSubtitle: 'Serving IT pioneers, scale-ups, and multinational tech campuses across Whitefield, Outer Ring Road, Koramangala, and Electronic City with fast PAN-India logistics, custom swag, and GST compliance.',
    heroImage: 'https://images.pexels.com/photos/14755150/pexels-photo-14755150.jpeg',
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Corporate Gifting', path: '/corporate-gifting' },
      { name: 'Corporate Gifts Bangalore', path: '/corporate-gifts-bangalore' },
    ],
    highlights: [
      { label: 'Tech Focus', value: 'Smart Swag & Audio' },
      { label: 'Doorstep Courier', value: 'Bangalore Metro & ORR' },
      { label: 'Customization', value: 'Laser Engraving & UV' },
      { label: 'MOQ Flexibility', value: 'Starts at 25 Units' },
    ],
    valuePropsTitle: 'Why Bangalore’s Tech Leaders Choose WrapYourWish',
    valueProps: [
      {
        title: 'Modern Developer-Friendly Swag Kits',
        desc: 'Ergonomic laptop stands, spill-proof ceramic coffee tumblers, mechanical keyboard accessories, and high-spec braided fast-charging cables.',
        icon: 'Sparkles',
      },
      {
        title: 'Doorstep Delivery Across All Tech Corridors',
        desc: 'Reliable doorstep dispatches across Bellandur, Marathahalli, Manyata Tech Park, Bagmane Tech Park, and Electronic City.',
        icon: 'Truck',
      },
      {
        title: 'Warehousing & On-Demand Dispatch for Scale-ups',
        desc: 'Keep bulk inventory stored in our central distribution facilities and trigger on-demand dispatches to new hires joining your Bangalore teams.',
        icon: 'Clock',
      },
      {
        title: 'GST-Compliant Procurement',
        desc: 'Streamlined invoicing, dedicated customer relationship executive, and comprehensive tax compliance suited for IT procurement protocols.',
        icon: 'ShieldCheck',
      },
    ],
    featuredProducts: [
      {
        id: 'blr-dev-pack',
        name: 'The Silicon Valley Developer Welcome Kit',
        price: '₹ 2,299',
        tag: 'Tech Swag',
        category: 'Employee Onboarding',
        img: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e',
        alt: 'Silicon Valley developer welcome kit for Bangalore IT companies with ergonomic laptop stand and ceramic tumbler',
        desc: 'Foldable aluminum laptop stand, vacuum insulated ceramic tumbler, braided 3-in-1 cable, and dot-grid engineer notebook in custom branded box.',
      },
      {
        id: 'blr-startup-swag',
        name: 'The Bangalore Scale-up Swag Box',
        price: '₹ 1,699',
        tag: 'Startup Favorite',
        category: 'Employee Onboarding',
        img: 'https://images.unsplash.com/photo-1608755728617-aefab37d2edd',
        alt: 'Bangalore scale-up swag box with customized hoodie, stainless bottle, and sticker pack',
        desc: 'Heavyweight bio-washed branded hoodie, double-walled flask, metallic ballpoint pen, and holographic company laptop sticker set.',
      },
      {
        id: 'blr-client-apex',
        name: 'The Venture Elite Partner Hamper',
        price: '₹ 3,799',
        tag: 'Executive',
        category: 'Client Gifting',
        img: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48',
        alt: 'Venture elite partner client gift hamper with single-origin coffee and dry fruits in wooden crate',
        desc: 'Estate-grown Coorg Arabica coffee beans, manual ceramic coffee grinder, California almonds, and hand-poured soy candle.',
      },
      {
        id: 'blr-eco-hustle',
        name: 'The Eco-Tech Sustainable Work Hamper',
        price: '₹ 1,899',
        tag: 'Eco Friendly',
        category: 'Sustainable Gifts',
        img: 'https://images.unsplash.com/photo-1606498679463-30a0eb8824e1',
        alt: 'Eco-tech sustainable corporate work hamper with recycled cotton bag and wheat straw gadgets',
        desc: 'Wheat straw wireless charging pad, recycled cotton tote, bamboo desk organizer, and plantable seed notebook.',
      },
    ],
    faqs: [
      {
        q: 'Do you deliver corporate gifts and welcome kits to Bangalore offices and residential addresses?',
        a: 'Yes. We deliver directly to tech campuses in Whitefield, Electronic City, Manyata Tech Park, and Outer Ring Road, as well as to individual employee residential addresses across Bangalore.',
      },
      {
        q: 'What is the transit time from your fulfillment hub to Bangalore?',
        a: 'We utilize express air logistics for Bangalore shipments. Standard bulk orders and sample kits reach Bangalore within 2 to 3 business days.',
      },
      {
        q: 'Can Bangalore startups store onboarding kits with you and ship as employees join?',
        a: 'Yes! Our "Gifting-as-a-Service" model allows you to order in volume to lock in bulk discounts, store the kits with us, and instruct us to dispatch individually as new engineers join.',
      },
      {
        q: 'Can we sample product items before placing a bulk order for our Bangalore team?',
        a: 'Yes, we express-courier prototype sample kits with your customized artwork and product options directly to your Bangalore office.',
      },
    ],
  },
};
